<template>
  <div v-loading="loading" style="margin:20px 30px;">
    <div class="notice-header" style="text-align: center;padding: 18px 0">
        <h2 class="title-A">{{ project.projectname }}</h2>
        <div class="line-A" style="color: #000;font-size: 18px;">报名信息</div>
        <div class="line-A"></div>
    </div>
    <div class="view-container">
      <div class="view-box">
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">项目编号</div>
            <div class="view-value">{{ project.projectcode }}</div>
          </div>
          <div class="view-field">
            <div class="view-label">平台编号</div>
            <div class="view-value">{{ project.projectno }}</div>
          </div>
          <div class="view-field">
            <div class="view-label">采购人</div>
            <div class="view-value">{{ project.pcomfullname }}</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">项目名称</div>
            <div class="view-content">{{ project.projectname }}</div>
          </div>
        </div>
        <div class="split-line"></div>
        <!-- <div class="view-row">
          <div class="view-field type">
            <div class="view-label">状态</div>
            <div class="view-value">
              <el-select v-model="query.status" :clearable="true" placeholder="全部">
                <el-option
                  v-for="item in pjnoticetypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="view-field">
          <div><el-button @click="getPageList" type='primary'>查询</el-button></div>
          <div class="view-value"></div>
          </div>
        </div> -->
      </div>
    </div>
    <div class="split-line"></div>
    <vggrid ref="xGrid" :list="list" tableheight="600" flexname="" :cols="cols" :showfooter="false" :showPage="true"
    @pagechange="pagechange"
      :resizable="true" :total="query.total" @cellClick="cellClick" @cellDblClick="viewProject">
    </vggrid>
  </div>
</template>
<script>
import request from '@/utils/request'
import MenuBtn from "../common/menuBtn"
import vggrid from '../common/vggrid'
import common from '@/mixin/common'
import dayjs from 'dayjs'
import utils from '../../assets/js/utils'
export default {
  name: 'psuIndexFile',
  mixins: [common],
  data() {
    return {
      project: {},
      btn: {},
      list: [],
      loading: false,
      pjnoticetypeList: [],
      cols: [
        { field: 'psucomfullname', fieldtype: 'C', title: '报名单位', calculExpr: '', addNewRowFlg: false },
        { field: 'psuusername', fieldtype: 'C', title: '报名人', calculExpr: '', addNewRowFlg: false },
        { field: 'psubmamt', fieldtype: 'C', title: '报名费', calculExpr: '', addNewRowFlg: false },
        { field: 'psubzjamt', fieldtype: 'C', title: '保证金', calculExpr: '', addNewRowFlg: false },
        { field: 'psuconfirmfeeamtdesc', fieldtype: 'C', title: '服务费', calculExpr: '', addNewRowFlg: false },
        { field: 'psutime', fieldtype: 'T', title: '报名时间', calculExpr: '', addNewRowFlg: false, formatter: ['toDateString', ''], width: 180 },
        { field: 'psustatusdesc', fieldtype: 'C', title: '状态', calculExpr: '', addNewRowFlg: false, width: 100,
          slots: {
              default: "default",
              default: ({ row }) => {
                if (+row.prsbmneedconfirm === 1 && +row.psustatus === 1 && row.psuAppendCount === 0 && dayjs(row.prsbmendtime).isBefore(dayjs())) {
                  return [<span>无效</span>]
                } else {
                  if (+row.psustatus === 1) {
                    return [<span>待审</span>]
                  } else if (+row.psustatus === 2) {
                    return [<span>驳回</span>]
                  } else if (+row.psustatus === 3) {
                    return [<span>通过</span>]
                  } else if (+row.psustatus === 4) {
                    return [<span>拒绝</span>]
                  }
                }
              }
            }
         },
        { field: 'psutypeCN', fieldtype: 'C', title: '报名方式', calculExpr: '', addNewRowFlg: false, width: 80 },
        {
          title: '操作 ', width: 100, showOverflow: true,
          slots: {
            default: 'default',
            default: ({ row }) => {
              return [<vxe-button type='primary' onClick={this.toPsu.bind(this, row)}>查看</vxe-button>]
            }
          }
        }
      ],
      query: {
        cosid: this.$store.getters.loginUser.cosid,
        projectid: this.$route.query.projectid,
        total: 0,
        limit: 20,
        offset: 0
      }
    }
  },
  created() {
  },
  activated() {
  },
  mounted() {
    this.init()
    this.getModel()
    this.getPjnoticetypeList()
    this.getPageList()
    this.getCosList()
  },
  watch: {
  },
  components: { vggrid },
  methods: {
    async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
    },
    async init() {
      this.query = {
        cosid: this.$store.getters.loginUser.cosid,
        projectid: this.$route.query.projectid,
        total: 0,
        limit: 20,
        offset: 0
      }
      this.btnLoading = false
      this.psu = {}
      this.list = []
      this.project = {}
    },
    async getModel() {
      this.project = await request({
        method: 'get',
        url: '/xmgl/project/findProjectById',
        params: this.query
      })
    },
    async getCosList() {
      let res = await request({
        method: "get",
        url: "/ywgl/cos/getCosbyid",
        params: { cosid: this.$store.getters.loginUser.cosid },
      });
      if (+res[0].cosshowfwf === 1 && this.$store.getters.loginUser.comtype == '2') {
        this.cols.splice(4, 1)
      }
    },
    async getPjnoticetypeList() {
      this.pjnoticetypeList = await request({
        url: '/kfgl/syscode/getSysCodeList',
        method: "get",
        params: { syscode: 'psustatus' }
      })
    },
    async getPsustatusList() {
      this.psustatusList = await request({
        url: '/kfgl/syscode/getSysCodeList',
        method: "get",
        params: { syscode: 'psustatus' }
      })
    },
    async getPageList() {
      this.loading = true
      await this.getPsustatusList()
      let res = await request({
        method: 'get',
        url: '/xmgl/project/getPsuInfoByProjectId',
        params: this.query
      })
      res.list.forEach(e => {
        e.psutypeCN = +e.psutype === 1 ? '公开' : '邀请'
        if (+e.psutype === 2) {
          if (+e.psustatus === 1) {
            e.psustatusdesc = '待接受'
          } else if (+e.psustatus === 3) {
            e.psustatusdesc = '己接受'
          } else if (+e.psustatus === 4) {
            e.psustatusdesc = '己拒绝'
          }
        }
        if (e.psucontactname && e.psucontactphone) {
          e.psuusername = e.psucontactname + " " + e.psucontactphone
        }
        if (Number(e.psubmamt) > 0) {
          let bmpayment = '(未付)'
          if (+e.psubmpaytype > 0 && +e.psubmpayflg !== 2) {
            bmpayment = '(待确认)'
          }
          if (+e.psubmpayflg === 1) {
            bmpayment = '(已付)'
          }
          e.psubmamt = utils.comdify(e.psubmamt) + bmpayment
        }
        if (Number(e.psubmamt) == 0) {
          e.psubmamt = '免费'
        }

        if (Number(e.psubzjamt) > 0) {
          let bzjpayment = '(未付)'
          if (+e.psubzjpaytype > 0 && +e.psubzjpayflg != 2) {
            bzjpayment = '(待确认)'
          }
          if (+e.psubzjpayflg === 1) {
            bzjpayment = '(已付)'
          }
          if (+e.psubzjreturnflg === 1) {
            bzjpayment = '(已退)'
          }
          e.psubzjamt = utils.comdify(e.psubzjamt) + bzjpayment
        }
        if (Number(e.psubzjamt) === 0) {
          e.psubzjamt = '免费'
        }

        if (Number(e.psuconfirmfeeamt) > 0) {

          let psufeement = '(未付)'
          if (+e.psufeepaytype > 0 && +e.psufewreceive !== 2) {
            psufeement = '(待确认)'
          }
          if (+e.psufewreceive === 1) {
            psufeement = '(已付)'
          }
          e.psuconfirmfeeamtdesc = utils.comdify(e.psuconfirmfeeamt) + psufeement
        }
        if (e.psuconfirmfeeamt === null) {
          e.psuconfirmfeeamtdesc = ''
        }
        else if (+e.psuconfirmfeeamt === 0) {
          e.psuconfirmfeeamtdesc = '免费'
        }
      });
      this.list = res.list
      this.query.total = res.count[0].count
      this.loading = false
    },
    btnClick(code) {
      this.$emit(code)
    },
    vggridClick(code, row) {
      this.psu = row
      this.$emit(code, row)
    },
    btnmenuclick(btn) {
      this.btn = btn
    },
    async cellClick(row) {
      this.psu = row.row
    },
    async close() {
      this.$store.commit('close_tab', { routeName: this.$route.name, vm: this, newRouteName: 'womIndex' })
    },
    async viewProject(row) {
      this.psu = row.row
      // this.$router.push({name: 'psuBmForm', params: {psuid: this.psu.psuid}})
    },
    async toPsu(row) {
      this.$router.push({ path: '/psuBmFile', query: { psuid: row.psuid } })
    }
  },
  filters: {
  }
}
</script>
<style lang="scss">
.btn-box {
  overflow: hidden;

  .vxe-button {
    padding: 10px 10px;
    font-size: 16px;
  }
}

.type {
  display: flex;
  align-items: center;
}
</style>
